module.exports = __webpack_public_path__ + "img/WeChatPay.c45aadca.png";